// // src/components/StartupKhataSettings.tsx
// import React, { useState, useEffect } from 'react';
// import { usePermissionGuard } from '../hooks/usePermissionGuard';
// import { Popup } from './Popup';
// import api from '../api/api';

// interface StartupKhataData {
//   email: string;
//   password: string;
//   connect_startupkhata: boolean;
// }

// interface StartupKhataSettingsProps {
//   isOpen: boolean;
//   onClose: () => void;
//   onSave?: () => void;
// }

// export function StartupKhataSettings({ isOpen, onClose, onSave }: StartupKhataSettingsProps) {
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [formData, setFormData] = useState<StartupKhataData>({
//     email: '',
//     password: '',
//     connect_startupkhata: false,
//   });
//   const { showError, showSuccess, popup, closePopup } = usePermissionGuard();

//   useEffect(() => {
//     if (isOpen) {
//       fetchStartupKhataData();
//     }
//   }, [isOpen]);

//   const fetchStartupKhataData = async () => {
//     setLoading(true);
//     try {
//       const response = await api.get('/get_startup_khata');
//       if (response.data) {
//         setFormData({
//           email: response.data.email || '',
//           password: response.data.password || '',
//           connect_startupkhata: response.data.connect_startupkhata || false,
//         });
//       }
//     } catch (err: any) {
//       console.error('Failed to fetch Startup Khata data:', err);
//       // Don't show error for 404 as it might be first time setup
//       if (err.response?.status !== 404) {
//         showError('FETCH_ERROR', err.message || 'Failed to load settings');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value,
//     }));
//   }; 

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
    
//     if (!formData.email.trim()) {
//       showError('VALIDATION_ERROR', 'Please enter email address');
//       return;
//     }
    
//     if (!formData.password.trim()) {
//       showError('VALIDATION_ERROR', 'Please enter password');
//       return;
//     }

//     setSaving(true);
//     try {
//       // Save Startup Khata settings
//       const saveResponse = await api.post('/create_or_update_startup_khata', {
//         email: formData.email,
//         password: formData.password,
//         connect_startupkhata: formData.connect_startupkhata,
//       });

//       if (saveResponse.data?.success !== false) {
//         showSuccess('Settings Saved', 'Startup Khata settings have been saved successfully');
        
//         if (onSave) {
//           onSave();
//         }
        
//         // Close modal after short delay
//         setTimeout(() => {
//           onClose();
//         }, 1500);
//       }
//     } catch (err: any) {
//       console.error('Failed to save settings:', err);
//       showError('SAVE_ERROR', err.response?.data?.detail || err.message || 'Failed to save settings');
//     } finally {
//       setSaving(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <>
//       {/* Backdrop */}
//       <div 
//         className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 transition-opacity duration-300"
//         onClick={onClose}
//       />

//       {/* Modal */}
//       <div className="fixed inset-0 z-50 overflow-y-auto">
//         <div className="flex min-h-full items-center justify-center p-4">
//           <div 
//             className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden animate-in fade-in zoom-in duration-300"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Header */}
//             <div className="sticky top-0 bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200 px-6 py-4">
//               <div className="flex justify-between items-center">
//                 <div className="flex items-center gap-3">
//                   <div className="w-10 h-10 bg-gradient-to-r from-gray-700 to-gray-900 rounded-xl flex items-center justify-center">
//                     <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//                     </svg>
//                   </div>
//                   <div>
//                     <h2 className="text-xl font-bold text-gray-900">Startup Khata Settings</h2>
//                     <p className="text-sm text-gray-500 mt-0.5">Configure your Startup Khata integration</p>
//                   </div>
//                 </div>
//                 <button
//                   onClick={onClose}
//                   className="p-2 hover:bg-gray-200 rounded-lg transition-colors"
//                 >
//                   <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>
//             </div>

//             {/* Form Body */}
//             <div className="p-6">
//               {loading ? (
//                 <div className="flex justify-center items-center py-12">
//                   <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//                 </div>
//               ) : (
//                 <form onSubmit={handleSubmit} className="space-y-5">
//                   {/* Email */}
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-1.5">
//                       Email Address <span className="text-red-500">*</span>
//                     </label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
//                         </svg>
//                       </div>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleChange}
//                         required
//                         placeholder="Enter your email"
//                         className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                       />
//                     </div>
//                   </div>

//                   {/* Password */}
//                   <div>
//                     <label className="block text-sm font-semibold text-gray-700 mb-1.5">
//                       Password <span className="text-red-500">*</span>
//                     </label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                         </svg>
//                       </div>
//                       <input
//                         type="password"
//                         name="password"
//                         value={formData.password}
//                         onChange={handleChange}
//                         required
//                         placeholder="Enter your password"
//                         className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                       />
//                     </div>
//                   </div>

//                   {/* Checkbox */}
//                   <div className="flex items-start gap-3 pt-2">
//                     <div className="flex items-center h-5">
//                       <input
//                         type="checkbox"
//                         name="connect_startupkhata"
//                         checked={formData.connect_startupkhata}
//                         onChange={handleChange}
//                         className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
//                       />
//                     </div>
//                     <div className="flex-1">
//                       <label className="text-sm font-medium text-gray-700 cursor-pointer">
//                         Connect to Startup Khata
//                       </label>
//                       <p className="text-xs text-gray-500 mt-0.5">
//                         Enable this to automatically sync employees with Startup Khata platform
//                       </p>
//                     </div>
//                   </div>

//                   {/* Info Box */}
//                   {formData.connect_startupkhata && (
//                     <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
//                       <div className="flex items-start gap-2">
//                         <svg className="w-4 h-4 text-blue-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                         </svg>
//                         <p className="text-xs text-blue-700">
//                           When enabled, employees will be synced with Startup Khata platform.
//                         </p>
//                       </div>
//                     </div>
//                   )}

//                   {/* Form Actions */}
//                   <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
//                     <button
//                       type="button"
//                       onClick={onClose}
//                       className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       disabled={saving}
//                       className="px-6 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md"
//                     >
//                       {saving ? (
//                         <>
//                           <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
//                             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                           </svg>
//                           Saving...
//                         </>
//                       ) : (
//                         'Save Changes'
//                       )}
//                     </button>
//                   </div>
//                 </form>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Popup for notifications */}
//       <Popup
//         isOpen={popup.isOpen}
//         type={popup.type}
//         title={popup.title}
//         message={popup.message}
//         onClose={closePopup}
//       />

//       <style>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }
//         @keyframes zoomIn {
//           from { transform: scale(0.95); opacity: 0; }
//           to { transform: scale(1); opacity: 1; }
//         }
//         .animate-in {
//           animation-duration: 0.2s;
//           animation-fill-mode: both;
//         }
//         .fade-in {
//           animation-name: fadeIn;
//         }
//         .zoom-in {
//           animation-name: zoomIn;
//         }
//       `}</style>
//     </>
//   );
// }

// src/components/StartupKhataSettings.tsx (Updated)
import React, { useState, useEffect } from 'react';
import { usePermissionGuard } from '../hooks/usePermissionGuard';
import { Popup } from './Popup';
import api from '../api/api';

interface StartupKhataData {
  email: string;
  password: string;
  connect_startupkhata: boolean;
}

interface StartupKhataSettingsProps {
  onSave?: () => void;
}

export function StartupKhataSettings({ onSave }: StartupKhataSettingsProps) {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  // Whether a credential exists server-side. The password itself never comes
  // back from the API, so this is the only way to tell "saved" from "not set".
  const [hasSavedPassword, setHasSavedPassword] = useState(false);
  const [formData, setFormData] = useState<StartupKhataData>({
    email: '',
    password: '',
    connect_startupkhata: false,
  });
  // Locked = already connected and not currently being edited — fields are
  // read-only and the connected credentials can't be overwritten by accident.
  const locked = formData.connect_startupkhata && !isEditing;
  const { showError, showSuccess, showWarning, popup, closePopup } = usePermissionGuard();

  useEffect(() => {
    fetchStartupKhataData();
  }, []);

  const fetchStartupKhataData = async () => {
    setLoading(true);
    try {
      const response = await api.get('/get_startup_khata');
      // The endpoint returns a LIST (one row per branch), not a single object —
      // reading response.data.email off the array yields undefined, so the form
      // showed blank despite data existing. Take the first record.
      const record = Array.isArray(response.data) ? response.data[0] : response.data;
      if (record) {
        // The password is NEVER sent back by the API — it is encrypted at rest
        // and returning it would put the Startup Khata password in the browser
        // on every page load. We only learn WHETHER one is saved, via
        // has_password, and the field stays empty.
        setFormData({
          email: record.email || '',
          password: '',
          connect_startupkhata: record.connect_startupkhata || false,
        });
        setHasSavedPassword(!!record.has_password);
        setIsEditing(!record.connect_startupkhata);
      }
    } catch (err: any) {
      console.error('Failed to fetch Startup Khata data:', err);
      // Don't show error for 404 as it might be first time setup
      if (err.response?.status !== 404) {
        showError('FETCH_ERROR', err.message || 'Failed to load settings');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.email.trim()) {
      showError('VALIDATION_ERROR', 'Please enter email address');
      return;
    }

    if (!formData.password.trim()) {
      showError('VALIDATION_ERROR', 'Please enter password');
      return;
    }

    setSaving(true);
    try {
      // The backend actually logs in to Startup Khata with these credentials
      // before saving — connect_startupkhata reflects a REAL, just-verified
      // connection, not a user-toggled intent.
      const saveResponse = await api.post('/create_or_update_startup_khata', {
        email: formData.email,
        password: formData.password,
        connect_startupkhata: formData.connect_startupkhata,
      });

      const record = Array.isArray(saveResponse.data) ? saveResponse.data[0] : saveResponse.data;
      const connected = !!record?.connect_startupkhata;

      // Clear the typed password from component state once it's saved — no
      // reason to keep it in memory, and the field re-renders as "saved".
      setFormData(prev => ({ ...prev, password: '', connect_startupkhata: connected }));
      setHasSavedPassword(!!record?.has_password);
      setIsEditing(!connected);

      if (connected) {
        showSuccess('Connected', record?.connection_message || 'Connected to Startup Khata');
      } else {
        showWarning(
          'Not Connected',
          record?.connection_message || 'Credentials saved, but Startup Khata login failed'
        );
      }

      if (onSave) {
        onSave();
      }
    } catch (err: any) {
      console.error('Failed to save settings:', err);
      showError('SAVE_ERROR', err.response?.data?.detail || err.message || 'Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await api.post('/disconnect_startup_khata');
      setFormData(prev => ({ ...prev, connect_startupkhata: false }));
      setIsEditing(true);
      showSuccess('Disconnected', 'Disconnected from Startup Khata');
    } catch (err: any) {
      console.error('Failed to disconnect:', err);
      showError('SAVE_ERROR', err.response?.data?.detail || err.message || 'Failed to disconnect');
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Startup Khata Settings</h2>
        <p className="text-sm text-gray-500 mt-1">Configure your Startup Khata integration</p>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-6 max-w-2xl">
          {/* Email */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Email Address <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                </svg>
              </div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={locked}
                placeholder="Enter your email"
                className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
              Password <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={locked}
                placeholder={
                  locked && hasSavedPassword
                    ? '•••••••• (saved)'
                    : hasSavedPassword
                      ? 'Re-enter password to update'
                      : 'Enter your password'
                }
                className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
              />
            </div>
          </div>

          {/* Connection status — set by the backend after an actual Startup Khata
              login attempt, not a user-toggled checkbox. */}
          <div
            className={`flex items-center gap-2 rounded-lg border p-4 ${
              formData.connect_startupkhata
                ? 'bg-green-50 border-green-200'
                : 'bg-gray-50 border-gray-200'
            }`}
          >
            <span
              className={`inline-block w-2.5 h-2.5 rounded-full ${
                formData.connect_startupkhata ? 'bg-green-500' : 'bg-gray-400'
              }`}
            />
            <p className={`text-sm font-medium ${formData.connect_startupkhata ? 'text-green-700' : 'text-gray-600'}`}>
              {formData.connect_startupkhata ? 'Connected to Startup Khata' : 'Not connected to Startup Khata'}
            </p>
          </div>

          {/* Form Actions. Each branch gets a distinct `key` so React unmounts/
              remounts the button on locked<->editing toggle instead of patching
              the same DOM node in place — reusing one node and flipping its
              type from "button" to "submit" mid-click can make the browser
              treat that same click as a form submission. */}
          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200">
            {locked ? (
              <React.Fragment key="locked-actions">
                <button
                  type="button"
                  onClick={handleLogout}
                  disabled={loggingOut}
                  className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loggingOut ? 'Logging out...' : 'Log out'}
                </button>
                <button
                  type="button"
                  onClick={() => setIsEditing(true)}
                  className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                >
                  Edit
                </button>
              </React.Fragment>
            ) : (
              <button
                key="save-action"
                type="submit"
                disabled={saving}
                className="px-6 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md"
              >
                {saving ? (
                  <>
                    <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Connecting...
                  </>
                ) : (
                  'Save & Connect'
                )}
              </button>
            )}
          </div>
        </form>
      )}

      {/* Popup for notifications */}
      <Popup
        isOpen={popup.isOpen}
        type={popup.type}
        title={popup.title}
        message={popup.message}
        onClose={closePopup}
      />
    </div>
  );
}

